<template>
  <div class="home">
  </div>
</template>

<script>
export default {
  name: 'AppHome'
}
</script>
